import { useState } from "react";
import InfoIcon from "../../../assets/icons/info-svgrepo-com.svg";
import { useSelector } from "react-redux";
import {
  CURRENCY_TYPE_FACTOR,
  getCurrencyTypeFromToken,
  langData,
  RootState,
  useAppSelector,
} from "@hypexone/uicore";

export const InfoTooltip = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { domainConfig } = useAppSelector((state) => state.common);
  const cFactor = CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()];
  const {
    cashableAmount,
    nonCashableAmount,
    balance,
    bonusRedeemed,
    exposure,
  } = useSelector((state: RootState) => ({
    cashableAmount: state.auth.balanceSummary?.cashableAmount,
    nonCashableAmount: state.auth.balanceSummary?.nonCashableAmount,
    balance: state.auth.balanceSummary.balance,
    bonusRedeemed: state.auth.balanceSummary.bonusRedeemed,
    exposure: state.auth.balanceSummary.exposure,
  }));

  return (
    <div className="inline-block">
      {domainConfig.depositWagering && domainConfig.b2cEnabled && (
        <div
          className="cursor-pointer"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <img src={InfoIcon} alt="info-btn" className="w-3 h-3 md:w-4 md:h-4" />
          {showTooltip && (
            <div
              className="bg-white h-auto w-auto z-50 absolute top-6 right-3 md:top-10 md:right-[8.5rem] rounded-md border border-gray1 p-2"
              style={{ boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.1)" }}
            >
              <div className="text-sm text-gray-700">
                <div className="flex mb-1">
                  <span>{langData?.["cashable"]}:</span>
                  <span className="font-medium">
                    {balance
                      ? (Number(cashableAmount / cFactor)).toFixed(2)
                      : 0.0}
                  </span>
                </div>
                <div className="flex">
                  <span>{langData?.["non_cashable"]}:</span>
                  <span className="font-medium">
                    {(
                      Math.max(nonCashableAmount, exposure) + bonusRedeemed
                    )?.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};